module.exports = {"id":"dp4_1l3q5","text":"Protecting Devices","instructions":"Which behaviour best reflects cybersecurity vigilance?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l3q5-a1","text":"Regularly reviewing security","score":3.7},{"id":"dp4_1l3q5-a2","text":"Setting once and forgetting","score":1.3},{"id":"dp4_1l3q5-a3","text":"Relying on default settings","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l3q5.json
// module id = 1211
// module chunks = 41